"use client";

import { FileExplorer } from "./code-panel/file-explorer";
import { EditorSurface } from "./code-panel/editor-surface";
import { useCodePanelController } from "./code-panel/use-code-panel-controller";

type CodePanelProps = {
  isActive: boolean;
  selectedFile?: string | null;
  onSelectedFileChange?: (path: string | null) => void;
};

export function CodePanel({
  isActive,
  selectedFile: controlledSelectedFile,
  onSelectedFileChange,
}: CodePanelProps) {
  const { fileExplorerProps, editorSurfaceProps } = useCodePanelController({
    isActive,
    controlledSelectedFile,
    onSelectedFileChange,
  });

  return (
    <div className="flex h-full w-full min-w-0 min-h-0">
      <FileExplorer {...fileExplorerProps} />
      <EditorSurface {...editorSurfaceProps} />
    </div>
  );
}
